<sliding-panel class="sliding-panel-payment-orders-history-log" [attr.data-test]="'file-history-log-panel'">
	<!-- Header -->
	<div class="header">
		<div class="title-section">
			<div class="text">
				<span>Payment Orders History Log</span>
			</div>
		</div>

		<div class="close-button" [attr.data-test]="'file-history-log-close-button'" (click)="closeLog.emit()">
			<app-icon
				[name]="'close'"
				[color]="'var(--color-text-default)'"
				[size]="'65'"
				[lineWidth]="'1px'"
			></app-icon>
		</div>
	</div>
	<div class="subheader">{{ getSubheader() }}</div>

	<div class="log-search" [formGroup]="searchForm">
		<mat-form-field id="searchLogfield" appearance="outline">
			<app-icon [name]="'search-normal-1'" size="17" matPrefix></app-icon>
			<input
				matInput
				class="search-box"
				placeholder="Search by"
				formControlName="search"
				[attr.data-test]="'textSearchLog'"
			/>
		</mat-form-field>
	</div>

	<div class="history-log-container">
		@for(historyItem of filteredItems; track $index){
		<div class="history-item-card">
			<div class="history-item-left">
				<div class="history-item-timestamp">{{ historyItem.createdAt | date : "HH:mm MMM d, y" }}</div>
				<div class="history-item-indicator">
					@if(historyItem.indicator === 'ERROR') {
					<div class="type-error"><span class="status-circle"></span><span>HAS ERRORS</span></div>
					} @else {
					<div class="type-completed">
						<span>Task Completed</span>
						<app-icon
							class="icon"
							name="tick"
							[lineWidth]="'1px'"
							[size]="'16'"
							[color]="'var(--complete-color)'"
						></app-icon>
					</div>
					}
				</div>
			</div>
			<div class="history-item-right">
				<div class="history-item-title" [attr.data-test]="'file-history-log-message-title-text'">
					@for(segment of historyItem.title; track $index) { @if ($index > 0) { {{ " " }} } @if(segment.style
					=== 'highlight') {
					<span class="highlight">{{ segment.text }}</span>
					} @else {
					<span>{{ segment.text }}</span>
					} }
				</div>
				<div class="history-item-subtitle" [attr.data-test]="'file-history-message-subtitle-text'">
					{{ historyItem.subtitle }}
				</div>
			</div>
		</div>
		} @empty {
		<no-items-layout [message]="'No records match your search'" [minHeight]="'35vh'"></no-items-layout>
		}
	</div>
</sliding-panel>
